import { useNavigate } from 'react-router-dom';
import * as routing from '../constants/Routing';

interface UseShowInfoSnackbarMessageResponseProps {
  sessionExpiredLogout: () => void;
}

// Hooks act as 'Adapter' layer.
export const useErrorMiddlewareOld = (): UseShowInfoSnackbarMessageResponseProps => {
  const navigate = useNavigate();

  const sessionExpiredLogout = () => {
    navigate(routing.LOGOUT);
  };

  return {
    sessionExpiredLogout,
  };
};
